import { render, staticRenderFns } from "./SingleUpload.vue?vue&type=template&id=3fdf87e5&scoped=true"
import script from "./SingleUpload.vue?vue&type=script&lang=js"
export * from "./SingleUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf87e5",
  null
  
)

export default component.exports